import { useState } from 'react';

import { format } from 'date-fns';

import { useTokenChartQuery } from '@query';

import { TokenPeriod } from '@api';

import { AreaChart, Chart, ChartFilter, ChartFilters } from '@ui/uikit/components/common/Chart';

const filters: ChartFilter<TokenPeriod>[] = [
  {
    value: '1d',
    label: '1D',
  },
  {
    value: '7d',
    label: '7D',
  },
  {
    value: '30d',
    label: '1M',
  },
  {
    value: '1y',
    label: '1Y',
  },
  {
    value: 'all',
    label: 'All',
  },
];

const getPeriodFormat = (period: TokenPeriod, timestamp: string) => {
  const date = new Date(timestamp);

  const isMidnight = date.getHours() === 0 && date.getMinutes() === 0;

  if (period === '1d') {
    return isMidnight ? 'dd MMM' : 'hh:mm a';
  }

  if (['7d', '30d', '3m', '6m', '1y'].includes(period)) {
    return 'dd MMM';
  }

  return 'dd MMM yyyy';
};

export const PredictionChart = () => {
  const [selectedPeriod, setSelectedPeriod] = useState<TokenPeriod>('1d');
  const tickFormatter = (time: string) =>
    format(new Date(time), getPeriodFormat(selectedPeriod, time));

  const { data: tokenChart = [], isPending: isTokenChartLoading } = useTokenChartQuery({
    tokenId: 'binancecoin',
    period: selectedPeriod,
  });

  return (
    <div className="h-[444px] w-full max-w-[1028px]">
      <Chart>
        <Chart.Plot>
          <AreaChart data={tokenChart} isLoading={isTokenChartLoading} xFormatter={tickFormatter} />
        </Chart.Plot>
        <Chart.Controls>
          <ChartFilters
            filters={filters}
            selectedValue={selectedPeriod}
            onSelect={setSelectedPeriod}
          />
        </Chart.Controls>
      </Chart>
    </div>
  );
};
